export enum foldersActionTypes {
    UPLOADING_BOOK_IN_FOLDER = 'UPLOADING_BOOK_IN_FOLDER',
    UPLOADING_BOOK_IN_FOLDER_FAILED = 'UPLOADING_BOOK_IN_FOLDER_FAILED',
    BOOK_IN_FOLDER_SUCCESS = 'BOOK_IN_FOLDER_SUCCESS',
    ALL_FOLDERS_LOADING = 'ALL_FOLDERS_LOADING',
    ALL_FOLDERS_LOADED = 'ALL_FOLDERS_LOADED',
}